import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const GenerateReports = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FETCH_REPORTS_MODULE.FETCH_REPORTS_MODULE_TYPES:
      return { ...state, reportTypes: action.value };
    case actions.FETCH_REPORTS_MODULE.SELECTED_REPORTS_MODULE_TYPE:
      return { ...state, selectedReportType: action.value };
    case actions.FETCH_REPORTS_MODULE.FETCH_USER_GENERATED_REPORTS:
      return {
        ...state,
        generatedReports: action.value.items,
        totalReports: action.value.totalItems,
      };
    default:
      return state;
  }
};
export default GenerateReports;
